// extracted by mini-css-extract-plugin
export default {"menu":"FooterMenu_menu__ej7qi"};